import React, { useMemo, useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { useOrganizationUIContext } from "./OrganizationUIContext";
import OrganizationTable from "./organization-table/OrganizationTable";
import { OrganizationFilter } from "./organization-table/organization-filter/OrganizationFilter";
import { RoleChecker } from "../../../../RoleChecker";
import { Collapse } from "react-bootstrap";
import OrganizationExportFileModal from "./organization-export-file-modal/OrganizationExportFileModal";
import LoadingAnimation from "../../../../config/loading-animation/LoadingAnimation";
import { exportOrganization } from "../../_redux/organization/organizationCrud";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import ConfirmationDeleteModal from "../../../Project/pages/modal-for-project/ConfirmationDeleteModal";
import { updateSimpzStatus } from "../../_redux/organization/organizationAction";
import OrganizationActivatedModal from "./organization-activated-modal/OrganizationActivatedModal";
import { useDispatch } from "react-redux";
import { SIMPZ_STATUS } from "../../../../config/helper";
import * as actions from "../../_redux/organization/organizationAction";
import { useHistory } from "react-router-dom";

export const OrganizationCard = ({ match }) => {
  const [openFilter, setOpenFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({
    exportModal: false,
    activated: false,
    inactive: false
  });
  const [currentOrg, setCurrentOrg] = useState({});

  const organizationUIContext = useOrganizationUIContext();
  const organizationUIProps = useMemo(() => {
    return {
      newOrganizationButtonClick:
        organizationUIContext.newOrganizationButtonClick,
      queryParams: organizationUIContext.queryParams,
      setQueryParams: organizationUIContext.setQueryParams,
      openEditOrganizationPage: organizationUIContext.openEditOrganizationPage,
      openOrganizationFilePage: organizationUIContext.openOrganizationFilePage
    };
  }, [organizationUIContext]);

  const history = useHistory();

  const allowApprove = RoleChecker("Approval", "organization");
  const allowEdit = RoleChecker("Edit", "organization");

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Branch Action
    const filter = {
      ...organizationUIProps.queryParams.filter
    };
    if (match.params.value == "SUBMIT") {
      if (allowApprove) {
        filter.simpz_status = match.params.value;
      } else {
        history.push("/");
      }
    }
    if (match.params.value == "is_nearly_expired") {
      filter.is_nearly_expired = true;
    }
    dispatch(
      actions.fetchOrganizations({
        ...organizationUIProps.queryParams,
        filter: filter
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationUIProps.queryParams, dispatch]);

  const exportOrganizationData = async value => {
    setLoading(true);
    await exportOrganization(value)
      .then(res => {
        const url = URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", `${value.filename}.xlsx`);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(err => {
        console.log(`err`, err);
        toast.error("Gagal export data Lembaga");
      })
      .then(() => {
        setLoading(false);
        setModal(prev => ({ ...prev, exportModal: false }));
      });
  };

  const updateMpzStatus = values => {
    dispatch(
      updateSimpzStatus({ ...values, organization_uuid: currentOrg.uuid })
    ).then(res => {
      setModal(prev => ({
        ...prev,
        activated: false,
        inactive: false
      }));
      dispatch(
        actions.fetchOrganizations({ ...organizationUIProps.queryParams })
      );
      toast.success("Berhasil update MPZ!", toastOption);
    });
  };

  return (
    <>
      <LoadingAnimation open={loading} />
      <OrganizationExportFileModal
        show={modal.exportModal}
        onHide={() => setModal(prev => ({ ...prev, exportModal: false }))}
        onClick={exportOrganizationData}
        title="Export Data Lembaga"
        initialValues={{}}
      />
      <OrganizationActivatedModal
        title={`${
          currentOrg.is_activated ? "Nonaktifkan" : "Aktifkan"
        } Lembaga ${currentOrg.name}`}
        show={modal.activated}
        onHide={() => {
          setModal(prev => ({
            ...prev,
            activated: false,
            inactive: false
          }));
          setCurrentOrg({});
        }}
        onClick={updateMpzStatus}
        initialValues={{
          is_activated: true,
          end_date: currentOrg.end_date,
          organization_classification_uuid:
            currentOrg.organization_classification &&
            currentOrg.organization_classification.uuid,
          organization_classification_name:
            currentOrg.organization_classification &&
            currentOrg.organization_classification.name,
          status: SIMPZ_STATUS.ACTIVE
        }}
      />
      {/* Confirmation Disable Org Modal */}
      <ConfirmationDeleteModal
        title={`${
          currentOrg.is_activated ? "Nonaktifkan" : "Aktifkan"
        } Lembaga ${currentOrg.name}`}
        show={modal.inactive}
        onHide={() => {
          setModal(prev => ({
            ...prev,
            activated: false,
            inactive: false
          }));
          setCurrentOrg({});
        }}
        content={`Apakah anda yakin ingin ${
          currentOrg.is_activated ? "Nonaktifkan" : "Aktifkan"
        } Lembaga ${currentOrg.name}?`}
        onClick={() =>
          updateMpzStatus({
            is_activated: false
          })
        }
      />
      <Card>
        <CardHeader title="Daftar Lembaga">
          <CardHeaderToolbar>
            <button
              className="btn btn-outline-dark mx-1"
              onClick={() => setModal(prev => ({ ...prev, exportModal: true }))}
            >
              Export Lembaga
            </button>
            <button
              className="btn btn-warning mx-1"
              onClick={() => setOpenFilter(!openFilter)}
            >
              Pencarian
            </button>
            {RoleChecker("Create", "organization") && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={organizationUIProps.newOrganizationButtonClick}
              >
                Lembaga Baru
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Collapse in={openFilter}>
            <div id="collapse-filter-organization">
              <OrganizationFilter />
            </div>
          </Collapse>
          <OrganizationTable
            match={match}
            setCurrentOrg={setCurrentOrg}
            setModal={setModal}
            allowEdit={allowEdit}
          />
        </CardBody>
      </Card>
    </>
  );
};
